<div [style.display]="isVisible() ? 'block' : 'none'" class="item-container comment-wrapper" [id]="htmlId()">
  @if (!addedWhileProcessing()) {
    <div class="existing-comment-wrapper">
      <span class="user">[{{ userNameTrimmed() }}]</span>
      <span [ngClass]="[properties.style.toLowerCase(), 'existing-comment-text', 'preserve-newlines']">{{
        properties.text
      }}</span>
    </div>
  }

  @if (addedWhileProcessing()) {
    <div class="new-comment-wrapper">
      <label [for]="htmlId() + '_input'" class="comment-label">[{{ userNameTrimmed() }}]</label>
      <input
        type="text"
        [id]="htmlId() + '_input'"
        [formControl]="formControl!"
        (input)="onCommentChange($event)"
        (focus)="onCommentFocus($event)"
        class="comment-input" />
    </div>
  }
</div>
